import { LOOKUP_APIS } from 'common/constants/lookups';
import CacheService from './cache';

export class LookupsService {
  static async refreshAllLookups() {
    Object.keys(LOOKUP_APIS).forEach(key => {
      try {
        CacheService.remove(key);
        const getter = LOOKUP_APIS[key];
        CacheService.get<any>(key, getter);
      } catch (error) {
        console.error('Error refreshing lookup: ', error);
      }
    });
  }
}
